
(function(){
/* ============================================================================
   EL PREAMBULO DE LA LANDING

   Va antes del nucleo del selector y FUERA del envoltorio de la pagina.

   El orden importa y costo un rato entenderlo: el nucleo se extrae de
   `_casting.js` al compilar y queda en ambito global. Si los datos se
   declararan dentro del envoltorio de la landing, el nucleo no los veria y
   la pagina saldria en blanco sin un solo error visible.

   Las ayudas —esc, sinAcento, semNum— NO se declaran aqui: vienen dentro
   del propio nucleo, que se corta desde `function esc`. Declararlas dos
   veces tumbaba el bloque entero con un «Identifier already declared».
   ========================================================================== */
var D     = JSON.parse(document.getElementById("lp-datos").textContent);
var CRUDO = JSON.parse(document.getElementById("lp-crudo").textContent);
var CFG   = JSON.parse(document.getElementById("lp-cfg").textContent);

/* el estado que el nucleo espera encontrar puesto */
var marcador = {}, ficha = {genero:"", regalo:0, rama:""};


function esc(s){
  return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c]; }); }
function sinAcento(s){
  return String(s || "").normalize("NFD")
    .replace(/[̀-ͯ]/g, "").toLowerCase(); }
function semNum(t){
  var h = 2166136261;
  for(var i = 0; i < t.length; i++){ h ^= t.charCodeAt(i); h = Math.imul(h, 16777619); }
  return h >>> 0; }

/* ====================================================================
   EL GUION
   ==================================================================== */
var FAMILIAS = ["citrico","floral","frutal","cuero","limpio","amaderado","dulce"];

/* Cada carta reparte puntos entre familias. Nunca dice a qué huele: la
   familia es la traduccion, no la pregunta. */
var GUION = {

  quien: {
    p: "¿Para <em>quién</em> es?",
    cartas: [
      {b:"Para él",        s:"Masculino",   foto:"hombre", fam:["amaderado","cuero"],   set:{genero:"Caballero"}},
      {b:"Para ella",      s:"Femenino",    foto:"dama",   fam:["floral","dulce"],      set:{genero:"Dama"}},
      {b:"Para quien sea", s:"Sin género",  foto:"unisex", fam:["limpio","amaderado"],  set:{genero:"Unisex"}},
      {b:"Es un regalo",   s:"No es para mí", foto:"regalo", fam:[],               set:{regalo:1}, va:"regaloPara"}
    ]
  },
  regaloPara: {
    p: "¿Y para <em>quién</em> es el regalo?",
    cartas: [
      {b:"Para él",        s:"", foto:"hombre", fam:["amaderado","cuero"],  set:{genero:"Caballero"}},
      {b:"Para ella",      s:"", foto:"dama",   fam:["floral","dulce"],     set:{genero:"Dama"}},
      {b:"No estoy seguro",s:"Que le quede a cualquiera", foto:"unisex", fam:["limpio"], set:{genero:"Unisex"}}
    ]
  },

  /* La rama. Es la pregunta que mas informacion da y la unica que la
     gente contesta sin pensarlo. */
  escena: {
    p: "¿En qué <em>contexto</em> esperas que se use?",
    cartas: [
      {b:"La oficina", s:"Juntas, pasillos, café", fam:["cuero","amaderado","limpio"], foto:"escena-oficina", set:{rama:"oficina"}},
      {b:"La noche",   s:"Una cita, una cena",     fam:["dulce","cuero","floral"],     foto:"escena-noche", set:{rama:"noche"}},
      {b:"El diario",  s:"Todos los días",          fam:["limpio","citrico","frutal"],  foto:"escena-diario", set:{rama:"diario"}},
      {b:"El campus",  s:"Clases, amigos, prisa",   fam:["frutal","dulce","limpio"],    foto:"escena-campus", set:{rama:"campus"}}
    ]
  },

  /* Tres tomas por rama. Siempre entre DOS, siempre concretas, nunca
     sobre olor. */
  /* La rama de trabajo no pregunta por habitos —si llegas puntual o no— sino
     por lo que la persona quiere PROYECTAR y por el mundo donde pasa su dia.
     Cuatro opciones, no dos: son mundos, y un mundo se reconoce de un
     vistazo. */
  oficina: [
    {p:"¿Qué quieres <em>reflejar</em>?", cartas:[
      {b:"Frescura y energía", s:"Limpio, despierto, en movimiento", fam:["limpio","citrico"], foto:"ref-frescura"},
      {b:"Poder y elegancia", s:"Entras y se acomoda la sala", fam:["cuero","amaderado"], foto:"ref-poder"},
      {b:"Experiencia y tradición", s:"Alguien que ya vivió esto antes", fam:["amaderado","dulce"], foto:"ref-tradicion"},
      {b:"Confianza y calma", s:"Con quien todos quieren trabajar", fam:["dulce","limpio"], foto:"ref-calma"}]},
    {p:"¿Dónde pasa tu <em>día</em>?", cartas:[
      {b:"Un despacho de madera y cuero", s:"Libreros hasta el techo", fam:["cuero","amaderado"], foto:"ofi-despacho"},
      {b:"Un piso alto, mármol y luz", s:"Ventanales de suelo a techo", fam:["limpio","citrico"], foto:"ofi-marmol"},
      {b:"La ciudad de noche desde la ventana", s:"Las últimas luces encendidas", fam:["cuero","dulce"], foto:"ofi-noche"},
      {b:"Un loft de concreto", s:"Nada de más, todo a la vista", fam:["limpio","amaderado"], foto:"ofi-loft"}]},
    {p:"Cuando <em>ganas</em>", cartas:[
      {b:"Nadie se entera hasta el lunes", s:"Te lo guardas", fam:["amaderado","limpio"], foto:"gana-callado"},
      {b:"Se enteran desde el pasillo", s:"Y está bien", fam:["dulce","frutal"], foto:"gana-pasillo"}]}
  ],
  noche: [
    {p:"El <em>plan</em>", cartas:[
      {b:"Cena larga, mantel, poca luz", s:"Sin prisa", fam:["dulce","cuero"], foto:"noc-cena"},
      {b:"Nos vemos y ya veremos", s:"Terraza, ruido, gente", fam:["citrico","frutal"], foto:"noc-terraza"}]},
    {p:"¿Cómo te <em>arreglas</em>?", cartas:[
      {b:"Algo oscuro y con textura", s:"Y un detalle que se nota de cerca", fam:["dulce","amaderado"], foto:"noc-oscuro"},
      {b:"Algo claro y recién planchado", s:"Sin nada que sobre", fam:["limpio","floral"], foto:"noc-claro"}]},
    {p:"Al <em>entrar</em> a un lugar", cartas:[
      {b:"Que volteen desde la puerta", s:"Llegaste y se supo", fam:["dulce","frutal"], foto:"noc-puerta"},
      {b:"Que solo lo sepa quien se acerque", s:"Para poca gente", fam:["limpio","amaderado"], foto:"noc-cerca"}]}
  ],
  diario: [
    {p:"Tu <em>mañana</em>", cartas:[
      {b:"Salgo de bañarme y ya", s:"Sin ceremonia", fam:["limpio","citrico"], foto:"dia-banarse"},
      {b:"Me tomo mi tiempo", s:"Todo en su lugar", fam:["floral","amaderado"], foto:"dia-tiempo"}]},
    {p:"Tu <em>lugar</em>", cartas:[
      {b:"Playa, sal, ventana abierta", s:"Aire moviéndose", fam:["limpio","citrico"], foto:"dia-playa"},
      {b:"Bosque, lluvia, suéter", s:"Todo quieto", fam:["amaderado","cuero"], foto:"dia-bosque"}]},
    {p:"Tu <em>antojo</em>", cartas:[
      {b:"Fruta fría", s:"Recién cortada", fam:["frutal","citrico"], foto:"dia-fruta"},
      {b:"Pan dulce recién hecho", s:"Todavía tibio", fam:["dulce","amaderado"], foto:"dia-pan"}]}
  ],
  campus: [
    {p:"Tu <em>grupo</em>", cartas:[
      {b:"Los que llegan riéndose", s:"Se oyen antes de verse", fam:["frutal","dulce"], foto:"cam-grupo"},
      {b:"El que se sienta atrás", s:"Y se entera de todo", fam:["amaderado","cuero"], foto:"cam-atras"}]},
    {p:"Tu <em>prenda</em>", cartas:[
      {b:"Sudadera limpia", s:"La misma de siempre", fam:["limpio","citrico"], foto:"cam-sudadera"},
      {b:"Chamarra de piel heredada", s:"Con historia encima", fam:["cuero","amaderado"], foto:"cam-chamarra"}]},
    {p:"Al <em>salir</em>", cartas:[
      {b:"Café con leche y galleta", s:"Y a platicar", fam:["dulce","floral"], foto:"cam-cafe"},
      {b:"Cancha, sol, agua fría", s:"Y a moverse", fam:["citrico","limpio"], foto:"cam-cancha"}]}
  ],

  /* Los cuatro mundos. Son arquetipos que todo el mundo reconoce —el
     socio, el que aprende rapido, la corte, el bosque antiguo— pero con
     nombre de la casa. La auditoria de agosto se resume en «el sitio le
     presta a otras casas el espacio donde deberia construir la suya»:
     poner series de HBO en esta pantalla seria el mismo error con otro
     traje. En el mostrador la asesora si puede nombrarlas de boca. */
  /* La ultima. Antes era «si tu vida fuera una historia» con cuatro mundos
     —La Torre, El Verano, La Corte, El Bosque—: arquetipos literarios que
     no le dicen nada a quien esta parado en el mostrador y que no ayudan a
     decidir. Es el mismo problema que el CSV senalo en la de «¿como
     entras?»: una pregunta de trivia en lugar de una util.

     Esta si sirve, y es la que hace una asesora: cuanto quieres que se
     note. Ademas es el diferenciador de la casa —elixir de alta
     concentracion— dicho en palabras de la clienta, y separa de verdad las
     familias: lo que proyecta contra lo que se queda cerca. */
  mundo: {
    p: "¿Qué tanto quieres que se <em>note</em>?",
    sub:"La última. No hay respuesta correcta.",
    cartas: [
      {b:"Que entre antes que yo",   s:"Se siente desde la puerta",
       fam:["dulce","cuero","frutal"],   foto:"not-estela", set:{mundo:"Estela"}},
      {b:"Que se note, sin gritar",  s:"Lo notan cuando ya estás cerca",
       fam:["amaderado","floral"],       foto:"not-media", set:{mundo:"Presencia"}},
      {b:"Solo quien se acerque",    s:"Para poca gente, y a propósito",
       fam:["limpio","amaderado"],       foto:"not-cerca", set:{mundo:"Secreto"}},
      {b:"Que dure todo el día",     s:"Me lo pongo temprano y ya",
       fam:["amaderado","dulce","cuero"],foto:"not-dura", set:{mundo:"Fondo"}}
    ]
  }
};

/* Un arquetipo por familia dominante. Todos invariables en genero: asi
   funcionan igual para él, para ella y para quien sea. */
var ARQUETIPO = {
  cuero:     {n:"ESTRATEGA",  d:"Habla al final, una sola vez, y se acaba la junta."},
  amaderado: {n:"CENTINELA",  d:"No se mueve. Por eso todo lo demás gira alrededor."},
  citrico:   {n:"INSURGENTE", d:"Llega primero y ya nadie lo alcanza."},
  limpio:    {n:"NAVEGANTE",  d:"Trae el aire de un sitio donde tú no estabas."},
  floral:    {n:"AMANTE",     d:"Se le queda algo a quien lo abraza."},
  frutal:    {n:"CÓMPLICE",   d:"Se ríe antes del final del chiste."},
  dulce:     {n:"ALQUIMISTA", d:"Convierte una tarde cualquiera en algo que se recuerda."}
};

/* ====================================================================
   EL MOTOR DE SELECCION — portado del sitio sin tocar
   ==================================================================== */
var KW = {
  citrico:['citric','bergamot','limon','lima','naranj','mandarin','pomelo','toronj','yuzu','petitgrain','verbena','cidra','kumquat','hesperid','citron','clementina','neroli'],
  floral:['floral','flor','rosa','jazmin','azahar','iris','violeta','peonia','lirio','gardenia','tuberosa','muguete','muguet','ylang','magnolia','nardo','mimosa','fresia','freesia','geranio','loto','orquidea','heliotropo','osmanto','lavanda'],
  frutal:['frutal','manzana','pera','durazno','melocoton','frambuesa','fresa','pina','melon','lichi','grosell','ciruela','mora','chabacano','mango','cereza','membrillo','higo','uva','maracuya','guayaba','papaya','nectarina','arandano','coco','frutos rojos','ruibarbo','datil'],
  cuero:['cuero','gamuza','ante ','tabaco','suede','cuir'],
  limpio:['almizcle','musk','jabon','algodon','acuat','marino','aldehid','ozon','brisa','lluvia','fresco','limpio','menta','te blanco','lino','sal marina','notas marinas','aire'],
  amaderado:['amader','madera','cedro','sandalo','vetiver','pachul','oud','agarwood','guaiac','gaiac','roble','abedul','amberwood','ambroxan','incienso','olibano','papiro','cipres','pino','musgo','oakmoss','ebano','palo santo','haya'],
  dulce:['vainilla','caramelo','azucar','miel','chocolate','cacao','praline','malvavisco','tonka','benjui','toffee','dulce','azucarado','leche','crema','haba tonka','regaliz','melaza']
};
var STIDX = {citrico:0, floral:1, amaderado:2, dulce:3, limpio:5};
var UMBRAL = 0.30;

function tieneKW(t, ks){
  for(var i = 0; i < ks.length; i++) if(t.indexOf(ks[i]) >= 0) return true;
  return false; }
function cuentaKW(t, ks){
  var n = 0;
  for(var i = 0; i < ks.length; i++) if(t.indexOf(ks[i]) >= 0) n++;
  return n; }
function fuerza(r, nota){
  var ks = KW[nota];
  var fam = sinAcento((r[3] || "") + " " + (r[4] || ""));
  var sal = sinAcento(r[5] || ""), cor = sinAcento(r[6] || ""),
      fon = sinAcento(r[7] || "");
  var famM = tieneKW(fam, ks) ? 1 : 0;
  var pres = (tieneKW(sal, ks) ? 0.44 : 0) + (tieneKW(cor, ks) ? 0.34 : 0) +
             (tieneKW(fon, ks) ? 0.30 : 0);
  var rich = Math.min(0.18, (cuentaKW(sal, ks) + cuentaKW(cor, ks) +
                             cuentaKW(fon, ks)) * 0.035);
  var st = 0;
  if(STIDX[nota] != null){
    var dg = parseInt((r[10] || "000000")[STIDX[nota]] || "0", 10) || 0;
    st = Math.min(1, dg / 6);
  }
  return Math.max(0, Math.min(1, 0.5 * famM + 0.42 * Math.min(1, pres) +
                                 0.28 * st + rich)); }
function puntajes(i){
  var r = CRUDO[i];
  if(r.__sc) return r.__sc;
  var sc = {};
  for(var k = 0; k < FAMILIAS.length; k++) sc[FAMILIAS[k]] = fuerza(r, FAMILIAS[k]);
  r.__sc = sc;
  return sc; }
function compat(i, el){
  if(!el.length) return 0;
  var sc = puntajes(i), suma = 0, min = 1;
  for(var j = 0; j < el.length; j++){
    var v = sc[el[j]]; suma += v; if(v < min) min = v; }
  var prom = suma / el.length;
  var s = (0.15 + 0.85 * prom) * (min >= UMBRAL ? 1 : 0.9);
  return Math.max(0, Math.min(100, Math.round(s * 100))); }
function tieneTodas(i, el){
  var sc = puntajes(i);
  for(var j = 0; j < el.length; j++) if(sc[el[j]] < UMBRAL) return false;
  return true; }
function coincidencias(el, genero){
  var out = D.map(function(d){ return {d:d, pct:compat(d.i, el)}; })
    .filter(function(o){
      if(o.d.para === "Ambiental") return false;
      if(genero && o.d.para !== genero) return false;
      if(el.length && (o.pct <= 0 || !tieneTodas(o.d.i, el))) return false;
      return true; });
  out.sort(function(a, b){
    return b.pct - a.pct || a.d.nombre.localeCompare(b.d.nombre, "es"); });
  return out; }
function pareja(d){
  var r = CRUDO[d.i], alt = null;
  for(var i = 0; i < CRUDO.length; i++){
    var s = CRUDO[i];
    if(s[1] === "Ambiental" || s[0] === r[0]) continue;
    if(s[4] !== r[4] && s[1] === r[1]){
      if(semNum(r[0] + s[0]) % 7 === 0){ alt = D[i]; break; }
      if(!alt) alt = D[i]; } }
  return alt; }

/* == EL TRADUCTOR ====================================================
   Aqui es donde la encuesta se convierte en lo que el motor ya sabe
   leer. No cambia su logica: le entrega las tres familias mas votadas
   igual que si alguien las hubiera pulsado. Si con tres no queda nada
   —puede pasar con una mezcla rara— se prueba con dos y con una, que es
   lo mismo que haria una persona quitando una nota. */
function elegir(){
  var orden = FAMILIAS.slice().sort(function(a, b){
    return (marcador[b] || 0) - (marcador[a] || 0) ||
           FAMILIAS.indexOf(a) - FAMILIAS.indexOf(b); });
  /* Se busca un conjunto que devuelva AL MENOS TRES: en el mostrador hay
     que poder poner tres frascos sobre la barra. Con tres familias y el
     umbral de 0.30 a veces solo pasan una o dos, y entonces se quita la
     familia menos votada —que es lo mismo que haria una persona— antes
     de tocar el genero. Lo que nunca se afloja es el umbral. */
  var mejor = null;
  for(var n = 3; n >= 1; n--){
    var el = orden.slice(0, n);
    var lista = coincidencias(el, ficha.genero);
    if(lista.length >= 3) return {el:el, lista:lista, genero:ficha.genero};
    if(lista.length && !mejor) mejor = {el:el, lista:lista, genero:ficha.genero};
  }
  for(var m = 3; m >= 1; m--){
    var el2 = orden.slice(0, m);
    var l2 = coincidencias(el2, "");
    if(l2.length >= 3) return {el:el2, lista:l2, genero:""};
    if(l2.length && !mejor) mejor = {el:el2, lista:l2, genero:""};
  }
  return mejor || {el:orden.slice(0, 1), lista:coincidencias([], ""), genero:""};
}

/* ====================================================================
   LA ESCENA
   ==================================================================== */

var LECTURA = {
  citrico:   {t:"Cítrico",   m:"con filo cítrico",
              c:"abre luminoso y se mueve rápido",
              si:["la mañana","el calor","la oficina","el gimnasio"],
              no:["una cena larga","el invierno"]},
  floral:    {t:"Floral",    m:"con corazón floral",
              c:"se queda cerca, suave y elegante",
              si:["el día","la primavera","ver gente","la oficina"],
              no:["el calor extremo"]},
  frutal:    {t:"Frutal",    m:"con toque frutal",
              c:"entra alegre y se nota de lejos",
              si:["el día","el fin de semana","el verano","salir"],
              no:["una reunión formal"]},
  cuero:     {t:"De cuero",  m:"con cuero debajo",
              c:"tiene cuerpo y carácter; no pasa desapercibido",
              si:["la noche","el frío","una cena","el invierno"],
              no:["la oficina de día","el calor"]},
  limpio:    {t:"Limpio",    m:"de estela limpia",
              c:"huele a recién bañado y se queda en la piel",
              si:["el diario","la oficina","el calor","cualquier hora"],
              no:["una noche que pide presencia"]},
  amaderado: {t:"Amaderado", m:"con fondo amaderado",
              c:"cálido y seco; se sostiene todo el día",
              si:["el otoño","el invierno","la oficina","la noche"],
              no:["el mediodía de calor"]},
  dulce:     {t:"Dulce",     m:"de fondo dulce",
              c:"envuelve y deja estela",
              si:["la noche","el frío","una cita","el invierno"],
              no:["la oficina de día","el calor"]}
};
var PROYECTA = {dulce:1, frutal:1, cuero:1};

function unir(lista, tope){
  var visto = {}, out = [];
  lista.forEach(function(x){
    if(!visto[x] && out.length < tope){ visto[x] = 1; out.push(x); } });
  if(out.length <= 1) return out[0] || "";
  return out.slice(0, -1).join(", ") + " y " + out[out.length - 1];
}

/* El nombre que se ensena es el DEL CATALOGO, no el nombre propio que
   genera `_datos_velantis.py`: en la tienda hay que poder pedirlo en la
   barra tal como esta rotulado el tester. */


/* ============================================================================
   LA LANDING DEL LAYERING

   EL EFECTO NO ES EL DEL CATALOGO.

   En el catalogo las notas se componen dentro de un lienzo: doce piezas en
   anillo alrededor del frasco, planas, todas al mismo foco, quietas hasta
   que alguien pasa el raton. Ahi funciona, porque ahi la imagen es la ficha
   de un producto y tiene que leerse de un vistazo.

   Aqui no hay lienzo. Cada nota es un ELEMENTO DE LA PAGINA con su sitio,
   su profundidad y su nombre, y por eso puede hacer tres cosas que dentro
   de un lienzo no podia:

     · tener profundidad de verdad —las de delante grandes y un poco fuera
       de foco, las de atras chicas y nitidas—, asi que al moverse se
       separan solas y la escena tiene aire;
     · pasar POR DELANTE y POR DETRAS del frasco en la misma cinta, que es
       lo que convierte un adorno en un espacio;
     · decir como se llama. La pagina afirma que cada pieza es un
       ingrediente de la formula; con el rotulo eso deja de ser una promesa
       y se puede comprobar.

   Las piezas son las mismas del catalogo, recortadas de `fotos-generadas`.
   Lo que cambia no es el material: es que aqui viven en el DOM.

   La forma tampoco es el anillo: es una CINTA que desciende serpenteando.
   Un anillo dice «esto es un producto». Una cinta que baja dice «esto
   ocurre en un orden» —arriba lo que hueles al abrir, abajo lo que queda a
   las seis horas—, que es exactamente lo que el texto esta contando.

   Arriba de este archivo va el nucleo del selector, extraido de
   `_casting.js` al compilar: la compatibilidad y la regla de pareja son las
   mismas que en la tienda, no una version parecida.
   ========================================================================== */
/* D, CRUDO y CFG vienen del preambulo global, junto al nucleo: el nucleo
   vive fuera de este envoltorio y tiene que verlos. */
var WA = CFG.wa, NOTAS = CFG.notas || {}, ACORDES = CFG.acordes || [];

function $(i){ return document.getElementById(i); }
function esca(s){
  return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }
function comoSeLlama(d){ return d.ref || d.nombre; }
function deQuienEs(d){ return d.casa || "Velantis"; }
function tope(v, a, b){ return v < a ? a : v > b ? b : v; }
function suave(t){ t = tope(t, 0, 1); return t * t * (3 - 2 * t); }
function entre(a, b, k){ return a + (b - a) * k; }

/* Un azar con memoria: la misma nota cae siempre en el mismo sitio, para
   que recargar la pagina no reordene la escena. */
function dado(s){
  var h = 2166136261;
  for(var i = 0; i < s.length; i++){
    h ^= s.charCodeAt(i); h = (h * 16777619) >>> 0; }
  return function(){
    h = (h * 1664525 + 1013904223) >>> 0; return h / 4294967296; };
}

/* ==========================================================================
   LAS PIEZAS

   Cada nota es una <figure> con tres partes: el resplandor de su color, la
   foto recortada y el rotulo. La <figure> solo se DESPLAZA; la foto de
   dentro es la que gira y crece. Separarlo asi deja que el rotulo viaje con
   la nota sin girar con ella, que de otro modo saldria del reves.
   ========================================================================== */
var AIRE = null, aire = [], cajaAire = {w:0, h:0};

function medirAire(){
  if(!AIRE) return;
  var r = AIRE.getBoundingClientRect();
  cajaAire.w = r.width || 1;
  cajaAire.h = r.height || 1;
}

function nacer(rol, nota, semilla){
  var g = NOTAS[(nota && nota.s) || "_polvo"] || NOTAS._polvo || [];
  if(!g.length) return null;
  var az = dado(semilla + (nota ? nota.s : "polvo"));
  var el = document.createElement("figure");
  el.className = "nota" + (rol === "polvo" ? " polvo" : "");
  var src = g[Math.floor(az() * g.length) % g.length];
  el.innerHTML = '<span class="brillo"></span><img alt="" src="' +
                 src + '">';
  if(nota && nota.c) el.style.setProperty("--tinte", nota.c);
  AIRE.appendChild(el);
  return {
    rol:rol, nota:nota, el:el,
    img:el.querySelector("img"),
    x:0.5, y:0.5, e:0.5, gir:0, op:0, z:0.5,          /* donde esta */
    dx:0.5, dy:0.5, de:0.5, dgir:0, dop:0, dz:0.5,    /* a donde va */
    zPuesto:-9, opPuesta:-9,
    v1:0.09 + az() * 0.13, f1:az() * 6.3, a1:0.008 + az() * 0.014,
    v2:0.07 + az() * 0.12, f2:az() * 6.3, a2:0.010 + az() * 0.018,
    v3:0.11 + az() * 0.19, f3:az() * 6.3, a3:3 + az() * 6,
    r:az()
  };
}

/* ---------------------------------------------------------- las formas */

/* LA CINTA. Desciende de arriba abajo serpenteando, y el serpenteo tambien
   la manda hacia delante y hacia atras: por eso unas notas tapan el frasco
   y otras quedan detras. `vueltas` es cuantas veces cruza. */
function cinta(i, n, o){
  var t = n < 2 ? 0.5 : i / (n - 1);
  var s = Math.sin(t * Math.PI * o.vueltas + o.fase);
  var c = Math.cos(t * Math.PI * o.vueltas * 0.88 + o.fase + 0.7);
  var z = 0.5 + c * 0.46;
  var x = o.cx + s * o.amp + (o.sesgo || 0);
  /* LA COLUMNA DEL FRASCO SOLO LA CRUZA QUIEN VA DELANTE.

     El frasco es grande y esta en el centro: una nota que caiga ahi y este
     por DETRAS desaparece entera, y con la mezcla —cinco y cinco— eso
     dejaba media escena sin nada que ver justo en el acto que lo explica.
     Las de delante si lo cruzan, y ese cruce es lo que le da hondura a la
     escena, asi que esas no se tocan. */
  if(z < 0.5){
    var d = x - o.cx;
    if(Math.abs(d) < 0.19) x = o.cx + (d < 0 ? -0.19 : 0.19);
  }
  return {x:x,
          y:o.y0 + t * (o.y1 - o.y0),
          z:z, gir:s * 22 + (i % 2 ? 10 : -8),
          e:(o.base || 0.42) + z * (o.rango || 0.86)};
}

/* EL AIRE SUELTO. Sin orden, ocupando todo, para el primer acto: ahi
   todavia no se habla de ninguna fragancia, solo de materias primas
   flotando. */
function suelto(p, base){
  return {x:0.08 + p.r * 0.84,
          y:0.05 + ((p.r * 7.13) % 1) * 0.90,
          z:0.18 + ((p.r * 3.71) % 1) * 0.74,
          gir:(p.r - 0.5) * 64,
          e:base + ((p.r * 5.29) % 1) * 0.60};
}

/* ==========================================================================
   LA COREOGRAFIA

   Un solo sitio decide donde va cada pieza, y lo decide en funcion de por
   donde va el dedo. No hay una animacion por seccion: hay una escena cuyo
   estado es una funcion de la posicion.
   ========================================================================== */
var UNA = null, OTRA = null, elegidaAhora = false, giroLento = 0;

function avance(el){
  if(!el) return 0;
  var r = el.getBoundingClientRect(), h = window.innerHeight;
  return tope((h - r.top) / (h + r.height), 0, 1);
}

function repartir(){
  var a0 = avance($("a0")), a1 = avance($("a1")),
      a2 = avance($("a2")), a3 = avance($("a3"));

  var junta = suave(Math.max(a0 * 0.62, a1 * 1.25));  /* se forma la cinta */
  var dos = suave(a2 * 1.18);                         /* entra la segunda  */
  var fin = suave(a3 * 1.3);                          /* el remate         */

  var nA = 0, nB = 0;
  for(var k = 0; k < aire.length; k++){
    if(aire[k].rol === "a") nA++; else if(aire[k].rol === "b") nB++; }

  /* La cinta empieza y acaba FUERA del escenario. Que la primera nota
     entre cortada por arriba y la ultima por abajo es lo que dice que la
     formula sigue mas alla del recuadro; encerrada dentro parecia un
     bodegon colocado. */
  /* La cinta se ABRE conforme avanza, no se cierra. Con el frasco grande,
     estrecharla al final metia las notas justo detras de el y la mezcla
     —que es el momento que la pagina esta contando— se quedaba sin nada
     que ensenar. Abriendola, las dos fragancias se reparten alrededor. */
  var comun = {cx:0.5, y0:-0.05, y1:1.05, fase:giroLento * 0.55,
               vueltas:entre(1.6, 2.2, fin), base:0.50,
               rango:entre(0.78, 0.92, fin)};
  var ia = 0, ib = 0;

  for(var i = 0; i < aire.length; i++){
    var p = aire[i], d;

    if(p.rol === "polvo"){
      d = suelto(p, 0.22);
      /* el polvo se retira cuando la cinta se forma: deja de ser el tema */
      d.op = entre(0.9, 0.13, junta);
      d.e *= entre(1, 0.72, junta);
    }else if(p.rol === "a"){
      var s = suelto(p, 0.34);
      /* dos fragancias comparten UNA cinta y se ALTERNAN en ella: si la
         primera ocupara la mitad de arriba y la segunda la de abajo, se
         leerian como dos cosas apiladas. Intercaladas, la mezcla se ve
         mezcla. */
      var f = cinta(nB && dos > 0.02 ? ia * 2 : ia,
                    nB && dos > 0.02 ? nA + nB : nA,
                    Object.assign({}, comun, {
                      amp:entre(0.44, 0.56, Math.max(dos, fin)),
                      sesgo:0}));
      d = {x:entre(s.x, f.x, junta), y:entre(s.y, f.y, junta),
           z:entre(s.z, f.z, junta), gir:entre(s.gir, f.gir, junta),
           e:entre(s.e, f.e, junta), op:1};
      ia++;
    }else{
      /* la segunda entra POR EL BORDE, desde fuera del escenario: se tiene
         que ver venir de otro sitio, no aparecer encima */
      var fu = {x:1.36, y:0.14 + (ib / Math.max(1, nB - 1)) * 0.72,
                z:0.62, gir:20, e:0.5};
      var fb = cinta(ib * 2 + 1, nA + nB,
                     Object.assign({}, comun,
                       {amp:entre(0.44, 0.56, Math.max(dos, fin)), sesgo:0}));
      var kk = suave(tope((dos - 0.05) / 0.70, 0, 1));
      d = {x:entre(fu.x, fb.x, kk), y:entre(fu.y, fb.y, kk),
           z:entre(fu.z, fb.z, kk), gir:entre(fu.gir, fb.gir, kk),
           e:entre(fu.e, fb.e, kk), op:dos > 0.01 ? 1 : 0};
      ib++;
    }

    p.dx = d.x; p.dy = d.y; p.dz = d.z;
    p.dgir = d.gir; p.de = d.e; p.dop = d.op;
  }

  aura(dos > 0.4 && OTRA ? OTRA : UNA);
  apartarTexto();
}

/* EL TEXTO SE QUITA DE LA MITAD DE LA ESCENA.

   En telefono las dos mitades son arriba y abajo, y el texto sube al
   desplazarse: sin esto, el ultimo parrafo de un acto termina escrito
   encima del frasco del siguiente. Se apaga en cuanto asoma por arriba de
   la linea que reparte la pantalla. En pantalla ancha no hace falta —cada
   uno tiene su lado— y se deja en 1. */
var estrecho = true, sobres = null;

function apartarTexto(){
  if(!sobres) sobres = document.querySelectorAll(".acto");
  var h = window.innerHeight, lee = h * 0.74;
  for(var i = 0; i < sobres.length; i++){
    var e = sobres[i], v = 1;
    if(estrecho){
      /* Manda el acto que cubre el PUNTO DE LECTURA —tres cuartos de
         pantalla, en medio de la mitad de abajo—, y solo ese. Antes se
         miraba si el texto habia subido por encima de la linea que reparte
         las mitades, y con actos clavados eso dejaba dos textos abajo a la
         vez: el que se iba todavia no habia subido y el que llegaba ya
         estaba puesto. Asi no puede pasar. */
      var r = e.getBoundingClientRect();
      var d = Math.min(lee - r.top, r.bottom - lee);
      v = tope(d / (h * 0.3), 0, 1);
    }
    var s = v.toFixed(2);
    if(e.dataset.vis !== s){
      e.dataset.vis = s;
      e.style.setProperty("--vis", s);
    }
  }
}

function medirAncho(){
  estrecho = !window.matchMedia("(min-width:900px)").matches;
}

/* El resplandor del fondo toma el color de la nota que manda en lo que se
   este contando. Es lo unico que se pinta de un color asignado: las fotos
   van con el color que ya traen. */
function aura(d){
  var caja = $("escena");
  if(!caja || !d) return;
  var a = ACORDES[d.i] || [];
  var col = (a[0] && a[0].c) || "#D4AF37";
  if(caja.dataset.aura === col) return;
  caja.dataset.aura = col;
  caja.style.setProperty("--aura", col);
}

/* ------------------------------------------------------------- el bucle
   Todo se mueve siempre, aunque nadie toque el scroll: una pagina que
   presume de que las notas flotan no puede ensenar una foto quieta.

   Cuesta poco porque por cuadro solo se escriben TRANSFORMACIONES, que el
   navegador resuelve en la tarjeta grafica sin volver a calcular la
   pagina. El desenfoque y la opacidad, que si cuestan pintura, se tocan
   solo cuando cambian de verdad. Y todo se para en seco cuando la pestana
   no esta a la vista.
   ========================================================================= */
var corriendo = false;

function paso(ahora){
  requestAnimationFrame(paso);
  var t = ahora / 1000;
  giroLento = t * 0.11;
  if(document.hidden || !AIRE || !cajaAire.w) return;

  if(!elegidaAhora) repartir();

  var W = cajaAire.w, H = cajaAire.h;
  for(var i = 0; i < aire.length; i++){
    var p = aire[i];
    /* se acerca a su destino poco a poco: asi los cambios de acto son un
       viaje y no un salto */
    p.x += (p.dx - p.x) * 0.075;
    p.y += (p.dy - p.y) * 0.075;
    p.e += (p.de - p.e) * 0.075;
    p.gir += (p.dgir - p.gir) * 0.06;
    p.z += (p.dz - p.z) * 0.06;
    p.op += (p.dop - p.op) * 0.06;

    /* la deriva: nunca esta del todo quieta */
    var fx = Math.sin(t * p.v1 * 6.28 + p.f1) * p.a1;
    var fy = Math.cos(t * p.v2 * 6.28 + p.f2) * p.a2;
    var fg = Math.sin(t * p.v3 * 6.28 + p.f3) * p.a3;

    p.el.style.transform = "translate3d(" +
      ((p.x + fx) * W).toFixed(1) + "px," +
      ((p.y + fy) * H).toFixed(1) + "px,0)";
    p.img.style.transform = "translate(-50%,-50%) rotate(" +
      (p.gir + fg).toFixed(1) + "deg) scale(" + p.e.toFixed(3) + ")";

    if(Math.abs(p.z - p.zPuesto) > 0.035){
      p.zPuesto = p.z;
      p.el.style.setProperty("--z", p.z.toFixed(3));
      p.el.style.zIndex = Math.round(p.z * 60);
    }
    if(Math.abs(p.op - p.opPuesta) > 0.03){
      p.opPuesta = p.op;
      p.el.style.setProperty("--op", p.op.toFixed(3));
    }
  }
}

function arrancarBucle(){
  if(corriendo) return;
  corriendo = true;
  requestAnimationFrame(paso);
}
function alRedimensionar(){ medirAire(); medirAncho(); }
window.addEventListener("resize", alRedimensionar, {passive:true});
window.addEventListener("orientationchange", alRedimensionar, {passive:true});

/* ==========================================================================
   QUE NOTAS SE ENSENAN

   Los acordes viajan aparte, en `CFG.acordes`, indexados igual que `D`.
   Antes se leian de `FRAGANCIAS`, dentro del motor; ahora el motor ya no
   viaja con la landing y esto es lo unico que hacia falta de el.
   ========================================================================== */
function acordesDe(d, n){
  var lista = (d && ACORDES[d.i]) || [];
  return lista.slice(0, n || 7).map(function(x, i){
    return {s:x.s, t:x.t, c:x.c, p:Math.max(46, 100 - i * 5)}; });
}

function poblar(a, b){
  for(var i = 0; i < aire.length; i++){
    if(aire[i].el.parentNode) aire[i].el.parentNode.removeChild(aire[i].el); }
  aire = [];
  var pol = (NOTAS._polvo || []).length;
  for(var k = 0; k < Math.min(4, pol); k++){
    var q = nacer("polvo", null, "polvo" + k);
    if(q){ q.r = ((k * 0.6180339887) + 0.11) % 1; aire.push(q); }
  }
  /* CINCO Y CINCO, NO SIETE Y SEIS.
     Catorce piezas en media pantalla de telefono no son una cinta, son un
     monton: no se distingue ninguna. Cinco de cada fragancia caben, se
     reconocen una por una y siguen siendo suficientes para que la mezcla
     se vea mezcla. */
  acordesDe(a, 5).forEach(function(nt, j){
    var w = nacer("a", nt, (a.sku || "a") + j);
    if(w) aire.push(w); });
  if(b) acordesDe(b, 5).forEach(function(nt, j){
    var w = nacer("b", nt, (b.sku || "b") + j);
    if(w) aire.push(w); });
  medirAire();
}

/* lo que aparece al entrar en pantalla */
if("IntersectionObserver" in window){
  var obs = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add("on"); obs.unobserve(e.target); }
    });
  }, {rootMargin:"0px 0px -12% 0px"});
  [].forEach.call(document.querySelectorAll(".rev"), function(el){
    obs.observe(el); });
}else{
  [].forEach.call(document.querySelectorAll(".rev"), function(el){
    el.classList.add("on"); });
}

/* ==========================================================================
   EL SELECTOR

   Las mismas preguntas del casting de tienda —viven en `GUION`, dentro del
   nucleo extraido— y el mismo `elegir()`.
   ========================================================================== */
var PLAN = [], cual = 0;

function pantalla(){
  var k = PLAN[cual];
  return typeof k === "string" ? GUION[k] : k;
}

function pintarPasos(){
  var h = "";
  for(var i = 0; i < PLAN.length; i++)
    h += '<i class="' + (i < cual ? "ya" : i === cual ? "on" : "") + '"></i>';
  $("pasos").innerHTML = h;
}

function render(){
  var q = pantalla();
  if(!q) return revelar();
  $("pregunta").innerHTML = q.p;
  $("cartas").innerHTML = q.cartas.map(function(c, i){
    var f = c.foto && FOTOS[c.foto];
    return '<button class="carta" type="button" data-i="' + i + '">' +
      (f ? '<span class="arte"><img src="' + f.src + '" alt=""></span>' : "") +
      '<span class="linea"><b>' + esca(c.b) + '</b>' +
      (c.s ? '<span>' + esca(c.s) + '</span>' : '') +
      '</span></button>'; }).join("");
  pintarPasos();
}

function sumar(carta){
  (carta.fam || []).forEach(function(f, i){
    marcador[f] = (marcador[f] || 0) + (4 - i); });
  Object.keys(carta.set || {}).forEach(function(k){ ficha[k] = carta.set[k]; });
}

$("cartas").addEventListener("click", function(e){
  var b = e.target.closest("[data-i]");
  if(!b) return;
  var q = pantalla(), c = q.cartas[+b.dataset.i];
  sumar(c);
  if(c.va) PLAN.splice(cual + 1, 0, c.va);
  if(ficha.rama && PLAN.indexOf(ficha.rama) < 0 && GUION[ficha.rama]){
    /* de la rama solo entran DOS preguntas: en una pagina que ya venia
       larga, seis toques es demasiado. Las dos primeras son las que mas
       separan. */
    var r = GUION[ficha.rama];
    PLAN.splice(cual + 1, 0, r[0], r[1]);
    ficha.rama = "";
  }
  cual++;
  render();
});

/* ------------------------------------------------------------ revelado */
var resultado = null, elegida = 0;

function revelar(){
  var r = elegir();
  var lista = r.lista.slice(0, 3);
  if(!lista.length) lista = D.slice(0, 3).map(function(d){ return {d:d}; });
  resultado = {el:r.el, recs:lista.map(function(o){ return o.d; })};

  var f1 = r.el[0], f2 = r.el[1] || r.el[0];
  var a = LECTURA[f1] || LECTURA.limpio, b = LECTURA[f2] || LECTURA.limpio;

  $("encuesta").hidden = true;
  $("resultado").hidden = false;
  $("pasos").innerHTML = "";

  $("pTitulo").textContent = a.t + (f2 !== f1 ? " " + b.m : "");
  $("pQueEs").innerHTML = "Es un aroma que <b>" + esca(a.c) + "</b>" +
    (f2 !== f1 ? ", " + esca(b.c) : "") + ". " +
    (PROYECTA[f1] ? "Se nota antes de que llegues."
                  : "Se descubre de cerca, no se anuncia.");
  $("pSi").textContent = unir(a.si.concat(b.si), 4);
  $("pNo").textContent = unir(a.no.concat(b.no), 3);

  $("pRecs").innerHTML = resultado.recs.map(function(d, k){
    return '<button class="rec" type="button" data-elige="' + k + '">' +
      '<span class="mini" data-rec="' + k + '"></span>' +
      '<div class="n"><b>' + esca(comoSeLlama(d)) + '</b>' +
      '<em>' + esca(deQuienEs(d)) + '</em>' +
      '<span class="sku">' + esca(d.sku) + '</span></div></button>';
  }).join("");
  [].forEach.call($("pRecs").querySelectorAll(".mini"), function(m){
    miniatura(m, resultado.recs[+m.dataset.rec]); });

  talla = tallaDeArranque();
  $("panel").classList.add("espera");
  $("resultado").scrollIntoView({block:"center"});
}

/* La miniatura de cada recomendacion se arma con las MISMAS piezas, en
   pequeno: tres notas y el frasco, tambien en el DOM. Que sea el mismo
   material es lo que hace que la tarjeta se lea como un trozo de la escena
   de arriba y no como otra cosa pegada debajo. */
function miniatura(caja, d){
  if(!d) return;
  var a = acordesDe(d, 3), h = "";
  var sitio = [[26, 28, 0.95, -14], [76, 42, 0.72, 17], [48, 76, 0.58, -6]];
  a.forEach(function(nt, k){
    var g = NOTAS[nt.s] || NOTAS._polvo || [];
    if(!g.length || !sitio[k]) return;
    var s = sitio[k];
    h += '<img class="mn" alt="" src="' + g[k % g.length] + '" style="left:' +
      s[0] + '%;top:' + s[1] + '%;--e:' + s[2] + ';--g:' + s[3] + 'deg">';
  });
  h += '<img class="mf" alt="" src="' + CFG.frasco + '">';
  caja.innerHTML = h;
  if(a[0] && a[0].c) caja.style.setProperty("--aura", a[0].c);
}

/* Tocar una recomendacion rehace la firma Y toma el escenario grande: la
   escena deja de contar la historia general y pasa a ser la suya. */
$("pRecs").addEventListener("click", function(e){
  var b = e.target.closest("[data-elige]");
  if(!b) return;
  elegida = +b.dataset.elige;
  bolsilloDe = 0;                      /* cada firma empieza por el primero */
  var d = resultado.recs[elegida];
  [].forEach.call($("pRecs").querySelectorAll(".rec"), function(el){
    el.classList.toggle("sel", +el.dataset.elige === elegida); });
  armarFirma(d);

  var par = pareja(d);
  elegidaAhora = true;
  poblar(d, par || null);
  colocarElegida();
});

/* Cuando alguien ya escogio, la escena se queda en SU cinta: ya no la
   manda el scroll, la manda su eleccion. */
function colocarElegida(){
  var nA = 0, nB = 0, i;
  for(i = 0; i < aire.length; i++){
    if(aire[i].rol === "a") nA++; else if(aire[i].rol === "b") nB++; }
  var ia = 0, ib = 0, total = nA + nB;
  for(i = 0; i < aire.length; i++){
    var p = aire[i];
    if(p.rol === "polvo"){
      var s = suelto(p, 0.20);
      p.dx = s.x; p.dy = s.y; p.dz = s.z; p.dgir = s.gir;
      p.de = s.e * 0.8; p.dop = 0.15;
      continue;
    }
    var puesto = p.rol === "a" ? (nB ? ia * 2 : ia) : ib * 2 + 1;
    if(p.rol === "a") ia++; else ib++;
    var f = cinta(puesto, nB ? total : nA, {
      cx:0.5, amp:0.52, sesgo:0, y0:-0.04, y1:1.04,
      vueltas:2.05, fase:0.4, base:0.52, rango:0.90});
    p.dx = f.x; p.dy = f.y; p.dz = f.z;
    p.dgir = f.gir; p.de = f.e; p.dop = 1;
  }
  aura(resultado ? resultado.recs[elegida] : UNA);
}

/* ==========================================================================
   EL CIERRE: QUE SE LLEVA, QUE VA DE REGALO Y CUANTO ES

   Tres cosas que antes no estaban y que son las que convierten una
   recomendacion en un pedido:

     · el FRASCO DE BOLSILLO de 30 ml que entra al llevarse los dos, y de
       cual de los dos lo quiere quien compra —es su firma, no la nuestra,
       asi que lo elige—;
     · el RESUMEN de lo que va a la caja, con el precio que la caja va a
       cobrar de verdad. No el del catalogo: si el resumen dijera un numero
       y el checkout otro, se estaria quemando a alguien que ya habia
       decidido comprar;
     · cuanto falta para el envio gratis.
   ========================================================================== */
var bolsilloDe = 0;        /* 0 = el primero, 1 = la pareja */
var talla = "100";         /* la presentacion elegida */

function pesos(n){
  return "$" + Number(n).toLocaleString("es-MX",
    {minimumFractionDigits:0, maximumFractionDigits:0});
}

/* Lo que la tienda puede cobrar de la presentacion elegida. Si esa talla
   todavia no esta dada de alta en Shopify, `id` sale nulo y el precio cae
   al de lista —el que fijo la casa—, que es lo que hay que ensenar
   mientras tanto. */
function enTalla(d, cual){
  var T = (CFG.tienda || {}).tallas || {};
  var b = T[cual || talla] || {};
  return {id:(b.variantes || {})[d.sku] || null,
          /* 3-sep: el gid se deriva del id numerico. El mapa dejo de traer `gid`
       porque con las dos tallas (541 + 541) no cabia en los 256 KB de un snippet. */
    gid:((b.gid || {})[d.sku]) || ((b.variantes || {})[d.sku] ? "gid://shopify/ProductVariant/" + b.variantes[d.sku] : null),
          precio:(b.precios || {})[d.sku] != null
                 ? b.precios[d.sku] : (b.lista || null)};
}

/* El precio del selector sale de la MISMA fuente que el del resumen: lo
   que la tienda cobra por esa fragancia en esa talla. Poniendo el de lista
   se veian dos numeros distintos para lo mismo —$390 arriba y $389 abajo—
   y eso, en la pantalla donde alguien decide pagar, se lee como un error. */
/* Las presentaciones que se ofrecen. Si la casa decidio vender una sola,
   `solo` la fija y no hay nada que elegir. */
function tallasQueVan(){
  var s = (CFG.tienda || {}).solo;
  return s ? [s] : ["50", "100"];
}

function pintarTallas(base){
  var ops = $("lTallasOps"), caja = $("lTallas");
  if(!ops) return;
  var lista = tallasQueVan();
  /* con una sola presentacion el selector sobra: elegir entre una cosa no
     es elegir, es un boton que no hace nada */
  if(caja) caja.hidden = lista.length < 2;
  if(lista.length < 2){ ops.innerHTML = ""; return; }
  ops.innerHTML = lista.map(function(k){
    var v = enTalla(base, k);
    return '<button class="opcion' + (k === talla ? " sel" : "") +
      '" type="button" data-talla="' + k + '">' +
      "<b>" + k + " ml</b><em>" +
      (v.precio == null ? "—" : pesos(v.precio)) + "</em></button>";
  }).join("");
}

/* CON CUAL SE ARRANCA.
   Con la de 100, que es la del paquete. Pero si esa talla todavia no esta
   dada de alta en Shopify, arrancar ahi deja la pantalla sin boton de pago
   —no hay variante que cobrar— y la pagina parece rota. Mientras tanto
   arranca en la que si se puede pagar, y el bloque del regalo hace de
   invitacion a subir. Se corrige sola el dia que se corra la carga. */
function tallaDeArranque(){
  var s = (CFG.tienda || {}).solo;
  if(s) return s;
  var T = (CFG.tienda || {}).tallas || {};
  var cien = (T["100"] || {}).variantes || {};
  return Object.keys(cien).length ? "100" : "50";
}

/* EL REGALO VA CON LA DE 100.
   El paquete que definio la casa es dos de 100 ml. Con la de 50 no aplica,
   y eso se dice en vez de esconderse. */
/* ==========================================================================
   LA ESCALERA

   Tres escalones: una fragancia, las dos, y las dos con el frasco de
   bolsillo. Cada uno arma su propio pedido y tiene su propio boton.

   Antes habia un solo boton, «Llevarme los dos», y quien solo queria una
   fragancia se quedaba sin forma de comprarla: la pagina la convencia de
   algo y luego le exigia el doble. Un escalon por decision deja que cada
   quien pare donde quiera, y pone el siguiente a la vista por si tienta.

   El del medio va marcado porque es el que la pagina viene contando desde
   arriba, no porque sea el mas caro.
   ========================================================================== */
function armarPedido(base, par, nivel){
  /* nivel 1 = solo la suya · 2 = el layering · 3 = el layering con regalo */
  var TIENDA = CFG.tienda || {}, BOLS = TIENDA.bolsillo || {};
  var UNICO = TIENDA.regalo || {};
  var cual = nivel === 3 ? (TIENDA.regaloDesde || "100") : talla;
  var lleva = nivel === 1 ? [base] : [base, par];

  var o = {nivel:nivel, talla:cual, lineas:[], completo:true, total:0,
           regalo:null, enlace:""};
  var piezas = [];
  lleva.forEach(function(x, k){
    if(!x){ o.completo = false; return; }
    var v = enTalla(x, cual);
    o.total += (v.precio || 0);
    /* El renglon se apunta AUNQUE la tienda no pueda cobrarlo todavia: la
       tarjeta tiene que ensenar que se llevaria y a que precio. Sin esto,
       el escalon de 50 ml salia en blanco —sin titulo y sin lista— porque
       esa presentacion aun no esta dada de alta, y una tarjeta vacia se lee
       como un error, no como «esto se aparta por WhatsApp». */
    o.lineas.push({gid:v.gid, papel:k ? "Encima" : "Primero",
                   sku:x.sku, nombre:comoSeLlama(x),
                   precio:v.precio, talla:cual});
    if(v.id) piezas.push(v.id + ":1");
    else o.completo = false;
  });

  if(nivel === 3 && par){
    var q = [base, par][bolsilloDe] || base;
    o.regalo = q;
    var b30 = BOLS[q.sku];
    if(o.completo && (b30 || UNICO.gid)){
      piezas.push((b30 ? b30.id : UNICO.id) + ":1");
      o.lineas.push({gid:b30 ? b30.gid : UNICO.gid,
                     papel:"Regalo del paquete", sku:q.sku + "-30",
                     fragancia:comoSeLlama(q) + " \u00b7 " + q.sku,
                     nombre:"Bolsillo 30 ml \u00b7 " + comoSeLlama(q),
                     precio:0, talla:"30"});
    }else{
      /* el frasco todavia no existe en la tienda: el escalon se ensena
         igual —es la oferta— pero se cierra por WhatsApp, que es lo que
         hoy si se puede cumplir */
      o.regaloSinAlta = true;
    }
  }

  o.enlace = (o.completo && piezas.length)
    ? "https://" + TIENDA.dominio + "/cart/" + piezas.join(",") : "";
  /* EL MENSAJE ES EL PEDIDO, NO UN AVISO.

     Antes era una linea suelta —«mi layering es A + B»— y del otro lado
     habia que volver a preguntar todo: que presentacion, cuanto es, de
     cual el de bolsillo. Escrito como una lista, quien atiende solo tiene
     que confirmar. */
  var S = String.fromCharCode(10);
  var texto = ["Hola, vengo de la p\u00e1gina. Quiero:", ""];
  o.lineas.forEach(function(l){
    texto.push("\u2022 " + l.nombre + " (" + l.sku + ")" +
      (l.precio ? " \u00b7 " + l.talla + " ml \u2014 " + pesos(l.precio)
                : " \u2014 incluido"));
  });
  if(o.regaloSinAlta && o.regalo)
    texto.push("\u2022 Frasco de bolsillo 30 ml de " +
               comoSeLlama(o.regalo) + " \u2014 incluido");
  texto.push("");
  texto.push("Total: " + pesos(o.total));
  o.mensaje = texto.join(S);
  o.nota = o.mensaje;
  return o;
}

var OFERTAS = [];

function pintarOfertas(base, par){
  var caja = $("lOfertas");
  if(!caja) return;
  var T = CFG.tienda || {};
  /* CUANTOS ESCALONES.

     Si ya se eligio la presentacion de 100, «las dos» y «las dos con el
     regalo» son la misma compra al mismo precio: el frasco entra solo. Dos
     tarjetas identicas con distinto titulo no son un upsell, son una
     duda. Ahi van dos escalones.

     Con la de 50 si hay tres, y el tercero cuesta mas y da mas: subir de
     presentacion es lo que destraba el regalo. Esa es la escalera de
     verdad. */
  var reg = (CFG.tienda || {}).regaloDesde || "100";
  var porChat = (CFG.tienda || {}).modo === "whatsapp";
  var ROT, BOT;
  if(!par){
    OFERTAS = [armarPedido(base, null, 1)];
    ROT = ["Solo la tuya"];
    BOT = ["Llev\u00e1rmela"];
  }else if(talla === reg){
    OFERTAS = [armarPedido(base, par, 1), armarPedido(base, par, 3)];
    ROT = ["Solo la tuya", "El layering, con tu frasco de bolsillo"];
    BOT = ["Llev\u00e1rmela", "Llevarme los dos"];
  }else{
    OFERTAS = [armarPedido(base, par, 1), armarPedido(base, par, 2),
               armarPedido(base, par, 3)];
    ROT = ["Solo la tuya", "El layering",
           "El layering en 100 ml, con tu frasco de bolsillo"];
    BOT = ["Llev\u00e1rmela", "Llevarme los dos",
           "Los dos en 100 y el de bolsillo"];
  }

  caja.innerHTML = OFERTAS.map(function(o, k){
    var manda = (OFERTAS.length > 1 && k === OFERTAS.length - 1);
    /* por el chat se aparta cualquier escalon, lo cobre la caja o no */
    var cerrable = o.completo || porChat;
    var h = '<article class="oferta' + (manda ? " manda" : "") +
      (cerrable ? "" : " sinCaja") + '" data-of="' + k + '">';
    h += '<span class="rot">' + ROT[k] + "</span>";
    h += "<b>" + o.lineas.filter(function(l){ return l.precio; })
           .map(function(l){ return esca(l.nombre); }).join(" + ") + "</b>";

    h += "<ul>";
    o.lineas.forEach(function(l){
      h += "<li" + (l.precio ? "" : ' class="gratis"') + "><span>" +
        esca(l.nombre) + (l.precio ? "<i>" + l.talla + " ml</i>" : "") +
        "</span><span>" +
        (l.precio ? pesos(l.precio) : "incluido") + "</span></li>";
    });
    if(o.regaloSinAlta && o.regalo)
      h += '<li class="gratis"><span>Bolsillo 30 ml · ' +
        esca(comoSeLlama(o.regalo)) + "</span><span>incluido</span></li>";
    h += "</ul>";

    /* de cual quiere el de bolsillo: solo tiene sentido en el tercero */
    if(o.nivel === 3 && par){
      h += '<div class="quien" id="lRegaloOps">' +
        [base, par].map(function(d, i){
          return '<button type="button" data-bols="' + i + '"' +
            (i === bolsilloDe ? ' class="sel"' : "") + ">" +
            esca(comoSeLlama(d)) + "</button>";
        }).join("") + "</div>";
    }

    h += '<div class="suma"><span>Total</span><b>' + pesos(o.total) +
         "</b></div>";
    var falta = (T.envio || 0) - o.total;
    h += '<p class="envio">' + (falta <= 0
      ? "<b>Env\u00edo gratis incluido.</b>"
      : "Faltan <b>" + pesos(falta) + "</b> para el env\u00edo gratis.") +
      "</p>";

    if(cerrable)
      h += '<button class="btn' + (manda ? "" : " fantasma") +
        (porChat ? " wa" : "") +
        '" type="button" data-compra="' + k + '">' + BOT[k] + "</button>";
    else
      h += '<p class="porWa">Esta presentaci\u00f3n todav\u00eda no est\u00e1 ' +
        "en l\u00ednea. Se aparta por WhatsApp.</p>";
    return h + "</article>";
  }).join("");
}

function armarFirma(base){
  var panel = $("panel");
  if(!panel || !base) return;
  panel.classList.remove("espera");

  var par = pareja(base);
  $("lBase").textContent = comoSeLlama(base);
  $("lBaseRef").textContent = deQuienEs(base) + " \u00b7 " + base.sku;
  if(par){
    $("lPar").textContent = comoSeLlama(par);
    $("lParRef").textContent = deQuienEs(par) + " \u00b7 " + par.sku;
  }else{
    $("lPar").textContent = "Brilla sola";
    $("lParRef").textContent = "Esta no necesita compa\u00f1\u00eda.";
  }
  $("lCodigo").textContent = par
    ? "Primero el " + base.sku + " en mu\u00f1ecas y cuello; encima el "
      + par.sku + ". As\u00ed, en ese orden."
    : "El " + base.sku + ", en mu\u00f1ecas y cuello.";

  pintarTallas(base);
  pintarOfertas(base, par);

  /* WhatsApp cierra el escalon mas alto que se pueda ofrecer. En modo
     chat sobra: seria el mismo boton tres veces. */
  var alto = OFERTAS[OFERTAS.length - 1];
  var wa = $("lWa");
  if((CFG.tienda || {}).modo === "whatsapp"){
    wa.hidden = true;
  }else{
    var SALTO = String.fromCharCode(10, 10);
    wa.href = WA + "?text=" + encodeURIComponent(
      alto.nota + (alto.enlace ? SALTO + alto.enlace : ""));
  }
}

/* ==========================================================================
   EL BOTON DE PAGO

   Arma el carrito con la API de la tienda y manda al checkout de Velantis.

   Se hace con `cartCreate` y no con el enlace `/cart/id:1` porque el enlace
   solo sabe decir «esta variante, una». La mutacion deja colgarle ATRIBUTOS
   a cada renglon y al pedido entero: cual es el primero, cual va encima, de
   cual quiere el frasco de bolsillo y que salio de la asesoria. Eso aparece
   en el panel de Shopify pegado a la orden, que es donde la casa lo
   necesita para prepararla; el enlace no lleva nada de eso y la orden
   llegaba muda.

   El token es el PUBLICO de Storefront: esta hecho para ir en el navegador
   y solo puede leer y armar carritos.

   Si la llamada falla —sin red, token cambiado, la tienda caida— se cae al
   enlace de siempre. Un boton que no hace nada es peor que uno que hace
   menos. */
var PEDIDO = null, pagando = false;

var CREAR = "mutation c($e:CartInput!){cartCreate(input:$e){" +
  "cart{checkoutUrl} userErrors{message}}}";

function irAPagar(boton, o){
  var T = CFG.tienda || {};
  PEDIDO = o;
  if(!o || !o.lineas.length) return;

  /* MODO WHATSAPP. El pedido se cierra en el chat: no hay carrito que
     armar, hay un mensaje que mandar. Se abre en otra pestana para no
     perder la pagina —quien no tenga WhatsApp de escritorio vuelve y
     sigue—. */
  if(T.modo === "whatsapp"){
    window.open(WA + "?text=" + encodeURIComponent(o.mensaje),
                "_blank", "noopener");
    return;
  }
  if(!T.token || !T.api || !window.fetch){
    if(o.enlace) window.location.href = o.enlace;   /* el enlace de siempre */
    return;
  }
  if(pagando) return;
  pagando = true;

  var dice = boton;
  var antes = dice.textContent;
  dice.textContent = "Preparando tu carrito…";

  var lineas = o.lineas.filter(function(l){ return l.gid; })
    .map(function(l){
      var at = [{key:"Layering", value:l.papel + " · " + l.sku}];
      if(l.fragancia) at.unshift({key:"Fragancia", value:l.fragancia});
      return {merchandiseId:l.gid, quantity:1, attributes:at};
    });
  if(!lineas.length){ pagando = false; dice.textContent = antes; return; }

  var atributos = [
    {key:"Origen", value:"Asesoría de layering · página"},
    {key:"Presentación", value:o.talla + " ml"}];
  if(o.regalo)
    atributos.push({key:"Frasco de bolsillo 30 ml",
                    value:comoSeLlama(o.regalo) + " · " +
                          o.regalo.sku + "-30"});

  var vuelve = function(){
    pagando = false; dice.textContent = antes;
    if(o.enlace) window.location.href = o.enlace;
  };

  fetch(T.api, {
    method:"POST",
    headers:{"Content-Type":"application/json",
             "X-Shopify-Storefront-Access-Token":T.token},
    body:JSON.stringify({query:CREAR, variables:{e:{
      lines:lineas, attributes:atributos, note:o.nota}}})
  }).then(function(r){ return r.json(); }).then(function(res){
    var c = res && res.data && res.data.cartCreate && res.data.cartCreate.cart;
    if(c && c.checkoutUrl){ window.location.href = c.checkoutUrl; return; }
    vuelve();
  })["catch"](vuelve);
}

$("lOfertas").addEventListener("click", function(e){
  var b = e.target.closest("[data-compra]");
  if(b){ irAPagar(b, OFERTAS[+b.dataset.compra]); return; }
  /* de cual quiere el frasco de bolsillo */
  var r = e.target.closest("[data-bols]");
  if(r && resultado){
    bolsilloDe = +r.dataset.bols;
    armarFirma(resultado.recs[elegida]);
  }
});

$("lTallasOps").addEventListener("click", function(e){
  var b = e.target.closest("[data-talla]");
  if(!b || !resultado) return;
  talla = b.dataset.talla;
  armarFirma(resultado.recs[elegida]);
});

$("pOtra").addEventListener("click", function(){
  PLAN = ["quien", "escena"]; cual = 0;
  marcador = {}; ficha = {genero:"", regalo:0, rama:""};
  resultado = null; elegida = 0; elegidaAhora = false;
  bolsilloDe = 0; talla = tallaDeArranque();
  $("resultado").hidden = true; $("encuesta").hidden = false;
  render();
  poblar(UNA, OTRA);
  $("elige").scrollIntoView({block:"start"});
});

/* ============================================================== arranque */
var FOTOS = CFG.fotos || {};

(function(){
  AIRE = $("aire");
  medirAncho();
  UNA = D[CFG.demo] || D[0];
  OTRA = pareja(UNA) || D[Math.min(D.length - 1, (CFG.demo || 0) + 40)];
  poblar(UNA, OTRA);

  PLAN = ["quien", "escena"];
  render();
  repartir();
  arrancarBucle();
  console.log("[landing] lista ·", D.length, "fragancias ·",
              aire.length, "piezas en el aire");
})();

})();

